const getCart = async () => {
  const result = await fetch('/cart.js')
  const json = await result.json()
  return json
}

const removeFromCart = async (variantId) => {
  try {
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    
    if (!cartItems) {
      throw new Error('Cart items element not found.');
    }

    await cartItems.removeItemSimple(variantId);

    console.log('Item removed successfully from the cart.');
  } catch (error) {
    console.error('An error occurred while removing the item from the cart:', error);
  }
}

const addMultipleToCart = async (items, data = {}) => {
  try {
    const requestData = {
      ...data,
      items,
      attributes: {
        ...((data && data.attributes) || {})
      }
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    return result;

  } catch (error) {
    console.error('Error:', error);
    throw error;  // If you want the error to propagate up
  }
}